import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kindSelect", "statusPresetWrapper"]

  connect() {
    this.toggleStatusField()
  }

  kindChanged() {
    this.toggleStatusField()
  }

  toggleStatusField() {
    const kindValue = this.kindSelectTarget.value
    const statusWrapper = this.statusPresetWrapperTarget

    if (kindValue === "general") {
      statusWrapper.classList.add("hidden")
    } else {
      statusWrapper.classList.remove("hidden")
    }
  }
}

